import React from 'react';

import NewPasswordForm from './NewPasswordForm';

const NewPassword = ({ locales }) => {
  return <NewPasswordForm locales={locales} />;
};

export default NewPassword;
